import React from 'react';

const ForbiddenPage = () => {
  return <div>ForbiddenPage</div>;
};

export default ForbiddenPage;
